import React from 'react';

const SellSellSellIntro = ({ leaving }) => (
  <>
    <div className={`fixed inset-0 z-60 flex items-center justify-center overflow-hidden intro-bg ${leaving ? 'intro-leave' : ''}`}>
      <div className="intro-sports" aria-hidden="true">
        {[
          { s: '⚽', x: '8%', y: '20%', size: '140px', blur: 5, rot: -8, o: 0.26 },
          { s: '🏀', x: '78%', y: '26%', size: '170px', blur: 6, rot: 8, o: 0.24 },
          { s: '🏏', x: '18%', y: '72%', size: '150px', blur: 7, rot: -12, o: 0.22 },
          { s: '🏒', x: '85%', y: '74%', size: '170px', blur: 7, rot: 6, o: 0.22 }
        ].map((it, i) => (
          <div
            key={i}
            className="sport intro-sport"
            style={{
              left: it.x, top: it.y,
              fontSize: it.size,
              filter: `blur(${it.blur}px) drop-shadow(0 10px 18px rgba(0,0,0,0.18))`,
              transform: `rotate(${it.rot}deg)`,
              opacity: it.o
            }}
          >
            {it.s}
          </div>
        ))}
        <div className="glow glow-a" />
        <div className="glow glow-b" />
      </div>

      <div className="absolute inset-0 opacity-10 overflow-hidden">
        {Array.from({ length: 12 }).map((_, i) => (
          <div
            key={i}
            className="absolute text-[7rem] font-black text-gray-600 select-none pointer-events-none intro-sell-text"
            style={{
              top: `${(i * 9) % 100}%`,
              left: `${(i * 15) % 100}%`,
              transform: `rotate(${(i * 30) % 360}deg)`
            }}
          >
            SELL!
          </div>
        ))}
      </div>

      <div className="relative z-10 w-full text-center px-4">
        <div className="select-none text-[5rem] sm:text-[8rem] md:text-[11rem] font-black text-transparent leading-none mx-auto mb-10 outline-sell animate-drift pointer-events-none">SELL!</div>
        <div className="select-none text-[4rem] sm:text-[7rem] md:text-[9rem] font-black text-red-500 leading-none mx-auto animate-float drop-shadow-2xl pointer-events-none">SELL!</div>
        <div className="select-none text-[5rem] sm:text-[8rem] md:text-[11rem] font-black text-transparent leading-none mx-auto mt-10 outline-sell animate-drift-rev pointer-events-none">SELL!</div>

        <div className="mt-10 text-lg md:text-xl text-gray-700">
          <span className="opacity-90 animate-pulse">Scroll to enter</span>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <svg className="w-8 h-8 text-gray-700" fill="currentColor" viewBox="0 0 24 24">
          <path d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z" />
        </svg>
      </div>
    </div>
    <style>{`
      .intro-bg {
        background:
          radial-gradient(1200px 600px at -10% 10%, rgba(255,255,255,0.55), transparent 60%),
          radial-gradient(1000px 600px at 110% 90%, rgba(255,255,255,0.35), transparent 65%),
          linear-gradient(120deg, #f9c2d6 0%, #f1d2e9 45%, #fff1d9 100%);
      }
      .intro-sports { position: absolute; inset: 0; z-index: 0; pointer-events: none; }
      .intro-sports .sport { mix-blend-mode: multiply; }
      .sport { position: absolute; line-height: 1; user-select: none; }
      .intro-sport { will-change: auto; }
      .intro-sell-text { will-change: auto; }

      .glow {
        position: absolute;
        width: 50vw; height: 50vw; max-width: 760px; max-height: 760px;
        border-radius: 50%;
        filter: blur(55px);
        opacity: 0.32;
        background: radial-gradient(closest-side, rgba(255,255,255,0.65), rgba(255,255,255,0));
      }
      .glow-a { left: -10vw; top: 6vh; }
      .glow-b { right: -12vw; bottom: -8vh; }

      .outline-sell {
        -webkit-text-stroke: clamp(2px, 0.6vw, 4px) rgba(255,255,255,0.7);
        text-shadow: 0 0 clamp(25px, 6vw, 35px) rgba(255,255,255,0.25);
      }

      @keyframes floatY {
        0% { transform: translateY(-12px) translateZ(0); }
        50% { transform: translateY(12px) translateZ(0); }
        100% { transform: translateY(-12px) translateZ(0); }
      }
      .animate-float { animation: floatY 4s ease-in-out infinite alternate; }

      @keyframes drift {
        from { transform: translateY(-18px) translateZ(0); }
        to { transform: translateY(18px) translateZ(0); }
      }
      .animate-drift { animation: drift 9s ease-in-out infinite alternate; }
      .animate-drift-rev { animation: drift 9s ease-in-out infinite alternate-reverse; }

      @keyframes introOut { to { opacity: 0; transform: scale(0.985) translateZ(0); } }
      .intro-leave { animation: introOut 0.6s ease forwards; }
    `}</style>
  </>
);

export default SellSellSellIntro;
